import { VARIANTES } from '../constantes';

export const PROGRESSO_VARIANTES = [
    ...VARIANTES,
];